import { z } from 'zod';

export const userNameSchema = z
  .string()
  .min(1, 'Required field')
  .min(2, 'Name must be at least 2 characters')
  .max(120, 'Name must not exceed 120 characters')
  .regex(/^[A-Za-z].*/, 'Name must start with letter')
  .regex(/.*[A-Za-z]$/, 'Name must end with letter')
  .regex(/^[\s'A-Za-z\-]*$/, "Name can only contain letters, spaces and -'");

export const optionalUserNameSchema = z
  .string()
  .min(2, 'Name must be at least 2 characters')
  .max(120, 'Name must not exceed 120 characters')
  .regex(/^[A-Za-z].*/, 'Name must start with letter')
  .regex(/.*[A-Za-z]$/, 'Name must end with letter')
  .regex(/^[\s'A-Za-z\-]*$/, "Name can only contain letters, spaces and -'")
  .or(z.literal(''));

export type UserName = z.infer<typeof userNameSchema>;
